import { useAccessibility } from "../../../../Store/contexts/AccessibilityContext";
import { ReembolsoAtencaoDetalhesData } from "../../../../interfaces/entities/ReembolsoAtencaoDetalhesData";
import "./styles.css";

const AtencaoDetalhes: React.FC<{ data: ReembolsoAtencaoDetalhesData }> = ({ data }) => {

  const accessibility = useAccessibility();

  return (
    <div className="atencao-data-card" style={{...accessibility.textStyleAccessibility, ...accessibility.contrastBorderAccessibility}}>
      <span dangerouslySetInnerHTML={{ __html: data.title }} />
      <span dangerouslySetInnerHTML={{ __html: data.text }} />
    </div>
  )
}

export default AtencaoDetalhes;